/**
 * ARIA's mark: the glowing "A" (public/aria-avatar.png, supplied by the owner 9/19/26) in a circle.
 * A fixed square plus `shrink-0` keep it round: the old letter-in-a-circle sat in a flex row and was
 * squeezed into an egg by the long VIN line beside it.
 */
export function AriaAvatar({ size = 40, className = '' }: { size?: number; className?: string }) {
  return (
    <img
      src="/aria-avatar.png"
      alt="ARIA"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`shrink-0 rounded-full object-cover ring-1 ring-white/15 shadow-lg shadow-purple-500/40 ${className}`}
      draggable={false}
    />
  );
}
